import { ActionReducerMap } from '@ngrx/store';
import { AssetDetailsPageState } from '../../../AppState';
import { ActionListReducer, AssetDocumentsReducer, AssetShapeReducer } from './asset-details-inline.reducers';

export const AssetDetailsInlineReducerMapper: ActionReducerMap<AssetDetailsPageState> = {
    DocumentGroupWidgetState: AssetDocumentsReducer,
    ShapeWidgetState: AssetShapeReducer,    
    ActionListWidgetState: ActionListReducer
};
